export default "__VITE_ASSET__CTz_x8em__"